/**
 * `Menu` inner bar heights in px. Sticky layouts (`SidebarLayout`, `StickyFilterBar`) offset their
 * pinned content by these, so the bar and anything pinned under it must read from here.
 * Some sticky offsets hardcode these as Tailwind values (e.g. `top-[54px] lg:top-[64px]`), so grep for
 * the pixel values too when changing them.
 */
export const MENU_BAR_HEIGHT_PX = 54;
export const MENU_BAR_HEIGHT_DESKTOP_PX = 64;
